import { useState } from 'react';

interface SearchFiltersProps {
  onSearch: (filters: {
    keyword: string;
    notificationItem: string;
    method: string;
    status: string;
    sendTimeStart: string;
    sendTimeEnd: string;
  }) => void;
}

export default function SearchFilters({ onSearch }: SearchFiltersProps) {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [filters, setFilters] = useState({
    keyword: '',
    notificationItem: '',
    method: '',
    status: '',
    sendTimeStart: '',
    sendTimeEnd: ''
  });

  const handleSearch = () => {
    onSearch(filters);
  };

  const handleReset = () => {
    const resetFilters = {
      keyword: '',
      notificationItem: '',
      method: '',
      status: '',
      sendTimeStart: '',
      sendTimeEnd: ''
    };
    setFilters(resetFilters);
    onSearch(resetFilters);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5">
      <div className="flex items-center gap-4 mb-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="搜索手机号/电子邮箱/用户名"
            value={filters.keyword}
            onChange={(e) => setFilters({ ...filters, keyword: e.target.value })}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg text-sm"
          />
        </div>
        <button
          onClick={() => setShowAdvanced(!showAdvanced)}
          className="px-4 py-2 text-sm text-teal-600 hover:bg-teal-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={`ri-filter-3-line mr-2`}></i>
          {showAdvanced ? '收起筛选' : '高级筛选'}
        </button>
        <button
          onClick={handleSearch}
          className="px-6 py-2 bg-teal-500 text-white text-sm rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line mr-2"></i>
          搜索
        </button>
      </div>

      {showAdvanced && (
        <div className="pt-4 border-t border-gray-200 space-y-4">
          <div className="grid grid-cols-4 gap-4">
            <div>
              <label className="block text-sm text-gray-700 mb-2">通知事项</label>
              <select
                value={filters.notificationItem}
                onChange={(e) => setFilters({ ...filters, notificationItem: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              >
                <option value="">全部</option>
                <option value="订单支付通知">订单支付通知</option>
                <option value="退款完成通知">退款完成通知</option>
                <option value="云电脑到期提醒">云电脑到期提醒</option>
                <option value="云电脑释放提醒">云电脑释放提醒</option>
                <option value="云电脑释放通知">云电脑释放通知</option>
                <option value="注册/登录验证码">注册/登录验证码</option>
                <option value="余额不足提醒">余额不足提醒</option>
                <option value="积分不足提醒">积分不足提醒</option>
                <option value="云存储不足提醒">云存储不足提醒</option>
                <option value="长期未登录唤醒通知">长期未登录唤醒通知</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">通知方式</label>
              <select
                value={filters.method}
                onChange={(e) => setFilters({ ...filters, method: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              >
                <option value="">全部</option>
                <option value="sms">短信通知</option>
                <option value="email">邮箱通知</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">通知状态</label>
              <select
                value={filters.status}
                onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              >
                <option value="">全部</option>
                <option value="success">成功</option>
                <option value="failed">失败</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">发送时间开始</label>
              <input
                type="datetime-local"
                value={filters.sendTimeStart}
                onChange={(e) => setFilters({ ...filters, sendTimeStart: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">发送时间结束</label>
              <input
                type="datetime-local"
                value={filters.sendTimeEnd}
                onChange={(e) => setFilters({ ...filters, sendTimeEnd: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              />
            </div>
          </div>

          <div className="flex items-center justify-end gap-3">
            <button
              onClick={handleReset}
              className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              重置
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
